import AcknowledgeInformation from './AcknowledgeInformation.vue';
import AcknowledgeInformationCorporate from './AcknowledgeInformationCorporate.vue';
import DiscussionThread from './DiscussionThread.vue';
import EBook from './Ebook.vue';
import ElearningPackage from './ElearningPackage.vue';
import FileSubmission from './FileSubmission.vue';
import FileSubmissionCorporate from './FileSubmissionCorporate.vue';
import Flashcard from './Flashcard.vue';
import LtiResourceLink from './LtiResourceLink.vue';
import LtiTool from './LtiTool.vue';
import Podcast from './Podcast.vue';
import PodcastCorporate from './PodcastCorporate.vue';
import Quiz from './quiz/Quiz.vue';
import QuizCorporate from './quiz/QuizCorporate.vue';
import SlideDeck from './SlideDeck.vue';
import SlideDeckCorporate from './SlideDeckCorporate.vue';
import Survey from './Survey.vue';
import VideoTemplate from './VideoTemplate.vue';
import ViewInformation from './ViewInformation.vue';
import ViewInformationCorporate from './ViewInformationCorporate.vue';

/**
 * activity_type values that render a DIFFERENT component than their own name.
 * Single source of truth for the dispatcher (CourseActivityTypes.componentType):
 *   'video'  -> the VideoTemplate renderer
 *   'survey' -> the Quiz renderer
 * Values are the kebab strings Vue resolves against the registry below.
 */
export const ACTIVITY_TYPE_ALIASES = {
    video: 'video-template',
    survey: 'quiz',
};

/**
 * Per-client renderer overrides for the CORPORATE redesign. The dispatcher
 * (CourseActivityTypes.componentType) swaps in these variants only when the
 * active client is corporate; stanbridge keeps the base renderers untouched.
 * Keyed by the resolved component key (post-alias). Add an entry as each
 * activity's corporate redesign lands. See docs/domains/activity-page.md.
 */
export const CORPORATE_RENDERER_OVERRIDES = {
    'view-information': 'ViewInformationCorporate',
    'acknowledge-information': 'AcknowledgeInformationCorporate',
    'slide-deck': 'SlideDeckCorporate',
    podcast: 'PodcastCorporate',
    'file-submission': 'FileSubmissionCorporate',
    quiz: 'QuizCorporate',
};

export default {
    ViewInformation,
    ViewInformationCorporate,
    AcknowledgeInformation,
    AcknowledgeInformationCorporate,
    FileSubmission,
    FileSubmissionCorporate,
    Podcast,
    PodcastCorporate,
    DiscussionThread,
    LtiResourceLink,
    LtiTool,
    Quiz,
    QuizCorporate,
    VideoTemplate,
    SlideDeck,
    SlideDeckCorporate,
    Survey,
    EBook,
    ElearningPackage,
    Flashcard,
};
